import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Gift, Copy, Share2, Users, Sparkles } from "lucide-react";

export const ReferralCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/vault/referral").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;

  const copy = () => { navigator.clipboard?.writeText(data.link); toast.success("Your invite link is copied"); };
  const share = async () => {
    if (navigator.share) { try { await navigator.share({ title: "ScorpPath Document Vault", text: data.share_text, url: data.link }); } catch { /* cancelled */ } }
    else copy();
  };

  return (
    <div className="bg-white border border-[#E5E5E5] rounded-2xl p-6" data-testid="referral-card">
      <div className="flex items-center gap-2 text-[#114A31]"><Gift className="h-5 w-5" /><span className="font-heading font-semibold">Invite a friend, get unlimited Tax Pal</span></div>
      <p className="mt-1 text-sm text-[#595D5A]">Every friend who joins with your link earns you <strong className="text-[#1C1C1C]">{data.reward_days} days of unlimited Tax Pal</strong> — chat, bank imports and the full planner.</p>
      <div className="mt-4 flex items-center gap-2 bg-[#F4F5F3] border border-[#E5E5E5] rounded-xl px-3 py-2.5">
        <code className="flex-1 text-xs text-[#114A31] font-semibold truncate" data-testid="referral-link">{data.link}</code>
        <button onClick={copy} className="p-1.5 text-[#595D5A] hover:text-[#114A31]" data-testid="referral-copy" title="Copy"><Copy className="h-4 w-4" /></button>
      </div>
      <div className="mt-3 flex items-center gap-3 flex-wrap">
        <Button onClick={share} data-testid="referral-share" className="rounded-full bg-[#114A31] hover:bg-[#1A6B46] text-white"><Share2 className="h-4 w-4 mr-2" /> Share link</Button>
        <span className="text-xs text-[#595D5A] flex items-center gap-1" data-testid="referral-friends"><Users className="h-3.5 w-3.5" /> {data.friends} friend{data.friends === 1 ? "" : "s"} joined</span>
        {data.days_left > 0 && !data.has_plan && (
          <span className="text-xs font-semibold text-[#114A31] bg-[#E6F0EB] px-2.5 py-1 rounded-full flex items-center gap-1" data-testid="referral-unlimited"><Sparkles className="h-3 w-3" /> Unlimited for {data.days_left} more day{data.days_left === 1 ? "" : "s"}</span>
        )}
      </div>
    </div>
  );
};

export default ReferralCard;
